import { useLocation, useNavigate } from "react-router-dom";
import { useLang } from "@/i18n/LanguageContext";

const NAV = [
  { to: "/app", key: "nav_home", icon: "fa-house" },
  { to: "/app/camera", key: "nav_camera", icon: "fa-camera" },
  { to: "/app/templates", key: "nav_templates", icon: "fa-clapperboard" },
  { to: "/app/filters", key: "nav_filters", icon: "fa-wand-magic-sparkles" },
  { to: "/app/training", key: "nav_training", icon: "fa-dumbbell" },
];

export default function BottomNav() {
  const location = useLocation();
  const navigate = useNavigate();
  const { t } = useLang();

  return (
    <nav className="fixed bottom-0 inset-x-0 z-40 px-3 pb-3 pt-2" data-testid="bottom-nav">
      <div className="glass rounded-3xl flex items-stretch justify-between px-1.5 py-1.5 max-w-lg mx-auto">
        {NAV.map((item) => {
          const active = location.pathname === item.to || (item.to !== "/app" && location.pathname.startsWith(item.to));
          const isHome = item.to === "/app" && location.pathname === "/app";
          const on = item.to === "/app" ? isHome : active;
          const label = t(item.key);
          return (
            <button
              key={item.to}
              data-testid={`nav-${label}`}
              onClick={() => navigate(item.to)}
              className="flex-1 flex flex-col items-center gap-1 py-2 rounded-2xl transition-colors"
              style={on ? { background: "linear-gradient(160deg, rgba(217,180,106,0.18), rgba(78,168,255,0.10))" } : {}}
            >
              <i className={`fa-solid ${item.icon} text-[17px] ${on ? "text-gold" : "text-slate-400"}`} />
              <span className={`text-[11px] ${on ? "text-gold font-bold" : "text-slate-400"}`}>{label}</span>
            </button>
          );
        })}
      </div>
    </nav>
  );
}
